import React, {Component} from 'react'
import { connect } from 'react-redux'
import EventEmitter from '../../../utils/events'

// import styles
import './linkorders.scss'

// Actions
import { LinkOrders, getLinkOrderData } from '../../../actions/orders'

// Utils
import { getStepName, makeOrderTypeIcon } from '../../../utils/order'
import { translation } from '../../../utils/helpers'

// import components
import Modal from '../../components/Modal'
import LinkDraftsModal from './LinkDraftsModal'
import ChooseDatesModal from './ChooseDatesModal'

// Elements
import Radio from '../../elements/radio'
import Icon from '../../elements/icon'
import LabelWrapper from '../../elements/labelWrapper'
import Inline from '../../elements/inline'
import Check from '../../elements/check'

import { ModalIcons } from '../../elements/icons'

class LinkOrdersModal extends Component {

  constructor (props) {
    super(props)
    this.state = {
      overflowHidden: false,
      lists: {
        AlreadyLinked: [],
        MatchingDrafts: [],
        MatchingRegNrs: [],
        MatchingProcessStep: [],
        MatchingOthers: []
      },
      selectedOrderIds: [],
      selectedDraft: 0,
      linkDraft: {
        open: false,
        matchingDraft: null,
        complete: false
      },
      chooseDates: {
        open: false,
        complete: false
      }
    }
    this.renderItem = this.renderItem.bind(this)
    this.renderRadioItem = this.renderRadioItem.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onRadioChange = this.onRadioChange.bind(this)
    this.deselect = this.deselect.bind(this)
    this.linkOrders = this.linkOrders.bind(this)
    this.completeLinkDraft = this.completeLinkDraft.bind(this)
    this.completeChooseDates = this.completeChooseDates.bind(this)
  }

  componentDidMount () {
    this.getLinkOrderData()
  }

  getLinkOrderData () {
    this.props.getLinkOrderData(this.props.id).then((res) => {
      let selectedOrderIds = []
      res.data.AlreadyLinked.map((val) => {
        selectedOrderIds.push(val.OrderId)
      })
      this.setState({
        lists: res.data,
        selectedOrderIds: selectedOrderIds
      })
    }, () => {
      window.toastr.error(translation('1932'), translation('216'))
      this.props.onClose()
    })
  }

  onInputChange (e) {
    let id = parseInt(e.target.value)
    let selectedOrderIds = [...this.state.selectedOrderIds]
    let isSelected = this.isSelected(id)
    if (isSelected !== false) {
      selectedOrderIds.splice(isSelected, 1)
    } else {
      selectedOrderIds.push(id)
    }
    this.setState({
      selectedOrderIds: selectedOrderIds
    })
  }

  isSelected (id) {
    let found = false
    this.state.selectedOrderIds.map((val, key) => {
      if (val === id && found === false) {
        found = key
      }
    })
    return found
  }

  onRadioChange (e) {
    let id = parseInt(e.target.value)
    let hasBeenCompleted = this.state.linkDraft.complete

    let selectedOrderIds = [...this.state.selectedOrderIds]
    const newSelected = selectedOrderIds.filter(s => s !== this.state.selectedDraft)

    if (id !== this.state.selectedDraft) {
      newSelected.push(id)

      if (hasBeenCompleted) {
        hasBeenCompleted = false
      }
    } else {
      id = 0
    }

    this.setState({
      selectedOrderIds: newSelected,
      selectedDraft: id,
      linkDraft: {
        ...this.state.linkDraft,
        complete: hasBeenCompleted
      }
    })
  }

  completeLinkDraft () {
    return this.setState({
      linkDraft: {
        ...this.state.linkDraft,
        complete: true,
        open: false
      }
    }, () =>
      this.linkOrders()
    )
  }

  completeChooseDates () {
    return this.setState({
      chooseDates: {
        ...this.state.chooseDates,
        complete: true,
        open: false
      }
    }, () => {
      this.linkOrders()
    }
    )
  }

  linkOrders (e) {
    if (e) e.preventDefault()

    const { linkDraft, chooseDates } = this.state
    let data = {
      MainOrderId: this.props.id,
      LinkOrderIds: this.state.selectedOrderIds
    }

    const { AlreadyLinked } = this.state.lists
    let shouldUnlink = false

    if (AlreadyLinked.length >= data.LinkOrderIds.length || data.LinkOrderIds.length === 0) {
      const allAlrLinked = AlreadyLinked.every(al => data.LinkOrderIds.includes(al.OrderId))
      const sameLength = data.LinkOrderIds.length === AlreadyLinked.length
      const isBigger = data.LinkOrderIds.length > AlreadyLinked.length

      if (AlreadyLinked.length === 0 || (allAlrLinked && (!isBigger || sameLength))) {
        return window.toastr.error(translation('14985'), translation('216'))
      } else if (AlreadyLinked.length > 0 && data.LinkOrderIds.length < AlreadyLinked.length) {
        // Should unlink orders
        shouldUnlink = true
      }
    }

    let draft = null
    if (!linkDraft.complete) {
      draft = this.state.lists.MatchingDrafts.find(mrn => data.LinkOrderIds.includes(mrn.OrderId))
      if (draft) {
        this.setState({
          linkDraft: {
            ...linkDraft,
            open: true,
            matchingDraft: draft.OrderId
          }
        })
      } else {
        return this.setState({
          linkDraft: {
            ...linkDraft,
            complete: true
          }
        }, () => this.linkOrders())
      }
    }

    if (!chooseDates.complete && linkDraft.complete) {
      this.setState({
        chooseDates: {
          ...chooseDates,
          open: true
        }
      })
    }

    if (shouldUnlink || (linkDraft.complete && chooseDates.complete)) {
      this.props.LinkOrders(data)
        .then((res) => {
          this.props.onClose()
          EventEmitter.emit('updateorderlist', true)
          // window.toastr.success(translation('2341'), translation('13424'))
        }, () => {
          window.toastr.error(translation('2342'), translation('216'))
        })
    }
  }

  renderItem (item, key) {
    let id = item.OrderId
    let name = !item.RegNr ? id : item.RegNr
    name += ','
    let label = (
      <Inline spacing={0}>
        <Icon icon={makeOrderTypeIcon(item.OrderType)} />
        {name} {translation(getStepName(item.StepId))}
      </Inline>
    )
    return (
      <Check key={key} id={'LinkOrder-' + id} name='LinkOrder' value={id} onChange={this.onInputChange} checked={this.isSelected(id) !== false} labelText={label} />
    )
  }

  deselect (e) {
    if (parseInt(e.target.value) === this.state.selectedDraft) {
      this.onRadioChange(e)
    }
  }

  renderRadioItem (item, key) {
    const id = item.OrderId
    let name = (item.RegNr === '') ? id : item.RegNr
    name += ','
    let label = (
      <Inline spacing={0}>
        <Icon icon={makeOrderTypeIcon(item.OrderType)} />
        {name} {translation('14722')}
      </Inline>
    )

    return (
      <Radio key={key}
        labelText={label}
        id={'LinkOrder-' + id}
        name='LinkOrder'
        value={id}
        onChange={this.onRadioChange}
        onClick={this.deselect}
        checked={this.state.selectedDraft === id} />
      // <div className='checkbox__custom clearfix' key={key}>
      //   <input
      //     type='radio'
      //     id={'LinkOrder-' + id}
      //     name='LinkOrder'
      //     value={id}
      //     onChange={this.onRadioChange}
      //     onClick={this.deselect}
      //     checked={this.state.selectedDraft === id} />
      //   <label htmlFor={'LinkOrder-' + id}>
      //     <img src={makeOrderTypeImage(item.OrderType)} />
      //     {name}, {translation('14722')}
      //   </label>
      // </div>
    )
  }

  renderView () {
    let { lists } = this.state
    return (
      <div>
        <LabelWrapper labelText={translation('1849')}>
          {lists.AlreadyLinked.length === 0 ? (
            <div>
              {translation('1850')}
            </div>
          ) : (
            <div className='linkItems'>
              {lists.AlreadyLinked.map(this.renderItem)}
            </div>
          )}
        </LabelWrapper>
        <LabelWrapper labelText={translation('14951')}>
          {lists.MatchingDrafts.length === 0 ? (
            <div>
              {translation('1855')}
            </div>
          ) : (
            <div className='linkItems'>
              {lists.MatchingDrafts.map(this.renderRadioItem)}
            </div>
          )}
        </LabelWrapper>
        <LabelWrapper labelText={translation('1851')}>
          {lists.MatchingRegNrs.length === 0 ? (
            <div>
              {translation('1855')}
            </div>
          ) : (
            <div className='linkItems'>
              {lists.MatchingRegNrs.map(this.renderItem)}
            </div>
          )}
        </LabelWrapper>
        <LabelWrapper labelText={translation('1852')}>
          {lists.MatchingProcessStep.length === 0 ? (
            <div>
              {translation('1855')}
            </div>
          ) : (
            <div className='linkItems'>
              {lists.MatchingProcessStep.map(this.renderItem)}
            </div>
          )}
        </LabelWrapper>
      </div>
    )
  }

  render () {
    const chooseDatesClose = () => {
      this.setState({
        chooseDates: {
          ...this.state.chooseDates,
          open: false
        }
      })
    }
    const linkDraftClose = () => {
      this.setState({
        linkDraft: {
          ...this.state.linkDraft,
          open: false
        }
      })
    }

    const showBackdrop = this.state.chooseDates.open || this.state.linkDraft.open ? ' linkorders__hide-backdrop' : ''

    return (
      <div className={'linkorders__modal' + showBackdrop}>
        <Modal {...this.props}
          header={translation('1848')}
          overflowHidden={this.state.overflowHidden}
          onClose={this.props.onClose}
          icon={ModalIcons.Link}
          bottomBarProps={{
            actionLabelText: translation('1854'),
            onActionClick: this.linkOrders
          }}
        >
          {this.renderView()}
        </Modal>
        {this.state.chooseDates.open &&
          <ChooseDatesModal
            onClose={chooseDatesClose}
            show={this.state.chooseDates.open}
            complete={this.completeChooseDates}
            mainOrderId={this.props.id}
            orderIds={this.state.selectedOrderIds} />}
        {this.state.linkDraft.open &&
          <LinkDraftsModal
            onClose={linkDraftClose}
            draftId={this.state.linkDraft.matchingDraft}
            mainOrderId={this.props.id}
            complete={this.completeLinkDraft}
            show={this.state.linkDraft.open} />}
      </div>
    )
  }

}

export default connect(null, {
  LinkOrders,
  getLinkOrderData
})(LinkOrdersModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/LinkOrdersModal/index.js